import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.css";
import "./brand/tokens.css";
import "./brand/components.css";
import "./brand/site.css";
import "./Modules/motion/motion.css";

// Keep the Odoo live chat out of the way while developing; the live site still shows it.
if (process.env.NODE_ENV === "development") {
	const hideChat = document.createElement("style");
	hideChat.textContent = ".o-livechat-root { display: none !important; }";
	document.head.appendChild(hideChat);
}

// Keep the Odoo live chat out of the way while developing; the live site still shows it.
if (process.env.NODE_ENV === "development") {
	const hideChat = document.createElement("style");
	hideChat.textContent = ".o-livechat-root { display: none !important; }";
	document.head.appendChild(hideChat);
}

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
    